import { encryptPayload } from "@/utils/cryptoUtils";
import { getPublicKey } from "@/api/request-encoding/getPublicKey";

export const validateOTP = async (mobile_number, otp, valid_minutes = 5) => {
  try {
    const publicKeyPem = await getPublicKey();
    const encryptedPayload = await encryptPayload(
      { mobile_number, otp, valid_minutes },
      publicKeyPem
    );

    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/validate_otp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(encryptedPayload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      return Promise.reject(errorData?.message || "OTP verification failed.");
    }

    return response.json();
  } catch (err) {
    console.error("OTP validation error:", err);
    return Promise.reject("Encryption or request error");
  }
};
